// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){ 

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    // CLOSE MAIN NAV MOBILE
    document.querySelectorAll('.close-menu').forEach(btn => {
        if ( document.querySelector('.navigation') ) {
            btn.addEventListener('click', e => {
                document.querySelector('.navigation').classList.remove('active');
            });
        }
    });

    // OPEN MAIN NAV MOBILE
    document.querySelectorAll('[data-show_nav_m]').forEach(btn => {
        if ( document.querySelector('.navigation') ) {
            btn.addEventListener('click', e => {
                document.querySelector('.navigation').classList.add('active');
            });
        }
    });

    $('[data-slick-goto]').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
        const target = $(this).data('slick-goto') ? parseInt( $(this).data('slick-goto') ) : 0;

        $curSlider.slick('slickGoTo', target);
        $(this).siblings('[data-slick-goto]').removeClass('active');
        $(this).addClass('active');
    });

    if (document.getElementById('terms_btn')) {
        let btnTerms = document.getElementById('terms_btn');
        let termsInfo = document.getElementById('terms_info');
        let termsInfoHeight = termsInfo.getElementsByClassName('wrap')[0].clientHeight;
        btnTerms.addEventListener('click', function(e) {
            e.preventDefault();
            termsInfo.classList.toggle('active');
            btnTerms.classList.toggle('active');
            if(termsInfo.classList.contains('active')){
                termsInfo.style.height = termsInfoHeight+"px";
            }else{
                termsInfo.style.height = 0+"px";
            }
        });
    }
    if(document.getElementById('tabletBurger')){
		
		document.getElementById('tabletBurger').addEventListener('click', function(){
			document.getElementById('primary-nav').classList.toggle('open')
			this.classList.toggle('open');
			
		})
	}

    let  showRfp = document.querySelectorAll('.showrfp');

    showRfp.forEach((button)=>{
        button.addEventListener('click', (e)=>{
            e.preventDefault();
            let groupsRfpForm = document.getElementById('groupsrfp-form');
            groupsRfpForm.style.display = 'block';
            let headerHeight = document.querySelector('header').offsetHeight;
    
            window.scrollTo({
                top: groupsRfpForm.offsetTop - headerHeight,
                behavior: 'smooth'
            });
        });
    });    

    if(document.querySelector('#groupsrfp-form')){
        let inputs = document.querySelectorAll('#groupsrfp-form input[type=number]');
        inputs.forEach((input)=>{
            input.setAttribute('max', '53');
            input.setAttribute('min', '1');
            input.addEventListener('input', validateNumber);
        });

        let close = '<div class="js-close-form close-form"><span>Close</span></div>';
        document.querySelector('#groupsrfp-form .form-module').insertAdjacentHTML('afterbegin',close);

        setTimeout(() => {
            document.querySelectorAll('.js-close-form').forEach((close)=>{
                close.addEventListener('click', ()=>{
                    document.getElementById('groupsrfp-form').style.display = 'none';
                })
            })
        }, 500);
    }
    

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
        if(!document.getElementById('header').classList.contains('scroll')){
            document.getElementById('header').classList.add('scroll');
        }
	} else {
        if(document.getElementById('header').classList.contains('scroll')){
            document.getElementById('header').classList.remove('scroll');
        }
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function validateNumber(event) {
    if(event.target.value>53){
        event.target.value = 53;
    }
    if(event.target.value<1){
        event.target.value = 1;
    }
}